export default{
  label:'grow',
  isResponsive:true,
  prefix:'flex',
  steps:[
    'grow-0',
    'grow-1'
  ]
}



// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/flex/grow.js